import anime from 'animejs';

export default class AnimationAPI {

    constructor() {
        this.unique_id  = 1;
        this.animations = {};
    }

    registeranimation(anim_conf, id=false){

        if(id) this.unregisteranimation(id);

        let self  = this;
        let index = self.unique_id;
        anim_conf.update=function(anim) {
            if(anim.completed) self.unregisteranimation(index);
        };
        anim_conf.autoplay=false;
        this.animations[this.unique_id] = anime(anim_conf);
        this.unique_id ++;

        return index;

    }

    checkanimating(animtocheck){
        return (this.animations[animtocheck])? true : false;
    }

    unregisteranimation(animtoremove){
        delete this.animations[animtoremove];
    }

    animate(t){

        for(let anim in this.animations){
            this.animations[anim].tick(t);
        }

        let self = this;
        requestAnimationFrame(function (t) {
            self.animate(t);
        });

    }


}

if(!window.hasOwnProperty('animationapi')) {
    window.animationapi = new AnimationAPI();
    window.animationapi.animate();
}




